function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M220.728,168.956l-8.427-38.206c2.793-6.18,4.208-12.768,4.208-19.609c0-15.451-7.482-29.837-19.848-38.754v-4.24 c0-8.236-6.701-14.937-14.938-14.937H160.98c-6.569,0-12.161,4.262-14.156,10.167h-31.708V23.921c0-2.761-2.239-5-5-5s-5,2.239-5,5 v39.456H73.408c-1.995-5.904-7.587-10.167-14.156-10.167H38.508c-8.236,0-14.938,6.701-14.938,14.937v1.844 C8.988,78.569,0.053,94.064,0.053,111.141c0,8.696,2.341,17.137,6.789,24.545L0.763,163.25c-3.751,17.01,6.695,34.216,23.286,38.355 c2.549,0.636,5.162,0.958,7.764,0.958c14.833,0,27.921-10.526,31.12-25.03l5.099-23.117c7.208-3.366,13.414-8.448,18.166-14.878 h44.157c5.625,7.595,13.363,13.356,22.215,16.543l4.731,21.452c3.199,14.503,16.286,25.03,31.119,25.03h0 c2.125,0,4.262-0.215,6.36-0.641c8.642-0.139,16.104-3.593,21.063-9.764C220.903,185.86,222.638,177.62,220.728,168.956z  M72.991,115.239c0,2.761-2.239,5-5,5H56.596v11.396c0,2.761-2.239,5-5,5h-9.584c-2.761,0-5-2.239-5-5v-11.396H25.616 c-2.761,0-5-2.239-5-5v-9.584c0-2.761,2.239-5,5-5h11.396V89.26c0-2.761,2.239-5,5-5h9.584c2.761,0,5,2.239,5,5v11.395h11.396 c2.761,0,5,2.239,5,5V115.239z M150.492,119.006c-5.142,0-9.326-4.183-9.326-9.325s4.184-9.326,9.326-9.326s9.326,4.184,9.326,9.326 S155.634,119.006,150.492,119.006z M169.67,138.184c-5.142,0-9.326-4.184-9.326-9.326c0-5.142,4.184-9.325,9.326-9.325 s9.325,4.183,9.325,9.325C178.995,134.001,174.812,138.184,169.67,138.184z M169.67,99.828c-5.142,0-9.326-4.184-9.326-9.326 s4.184-9.325,9.326-9.325s9.325,4.183,9.325,9.325S174.812,99.828,169.67,99.828z M188.848,119.006 c-5.142,0-9.325-4.183-9.325-9.325s4.183-9.326,9.325-9.326s9.326,4.184,9.326,9.326S193.99,119.006,188.848,119.006z"
});

var _ref3 = /*#__PURE__*/React.createElement("g", null);

var _ref4 = /*#__PURE__*/React.createElement("g", null);

var _ref5 = /*#__PURE__*/React.createElement("g", null);

var _ref6 = /*#__PURE__*/React.createElement("g", null);

var _ref7 = /*#__PURE__*/React.createElement("g", null);

var _ref8 = /*#__PURE__*/React.createElement("g", null);

var _ref9 = /*#__PURE__*/React.createElement("g", null);

var _ref10 = /*#__PURE__*/React.createElement("g", null);

var _ref11 = /*#__PURE__*/React.createElement("g", null);

var _ref12 = /*#__PURE__*/React.createElement("g", null);

var _ref13 = /*#__PURE__*/React.createElement("g", null);

var _ref14 = /*#__PURE__*/React.createElement("g", null);

var _ref15 = /*#__PURE__*/React.createElement("g", null);

var _ref16 = /*#__PURE__*/React.createElement("g", null);

var _ref17 = /*#__PURE__*/React.createElement("g", null);

var SvgGame = function SvgGame(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 221.485 221.485",
    style: {
      enableBackground: "new 0 0 221.485 221.485"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16, _ref17);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgGame, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/game.3d5c927a.svg";
export { ForwardRef as ReactComponent };